<template>
  <tr>
    <td>
      <p
        class="result-badge"
        :class="{
          'win-badge':
            getResult(this.match_details.teams.faction1.roster) == 'WIN',
          'lose-badge':
            getResult(this.match_details.teams.faction1.roster) == 'LOSE'
        }"
      >
        {{ getResult(this.match_details.teams.faction1.roster) }}
      </p>
    </td>
    <td>
      {{ formatDate(this.match_details.configured_at * 1000) }}
    </td>
    <td>{{ this.match_stats.rounds[0].round_stats.Score }}</td>
    <td>{{ `${Kills} - ${Assists} - ${Deaths}` }}</td>
    <td>
      <p
        class="result-badge"
        :class="{ 'win-badge': KdRatio >= 1, 'lose-badge': KdRatio < 1 }"
      >
        {{ KdRatio }}
      </p>
    </td>
    <td>{{ getTeamName(getFaction()) }}</td>
    <td>{{ this.match_details.voting.map.pick[0] }}</td>
  </tr>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "MatchTableItem",
  props: ["match_id"],
  data() {
    return {
      match_details: {},
      match_stats: {},
      player_stats: {},
      error: ""
    };
  },
  async created() {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_BEARER_KEY}`
      }
    };
    try {
      const details = await axios.get(
        `https://open.faceit.com/data/v4/matches/${this.$props.match_id}`,
        config
      );
      const stats = await axios.get(
        `https://open.faceit.com/data/v4/matches/${this.$props.match_id}/stats`,
        config
      );
      this.match_details = details.data;
      this.match_stats = stats.data;
    } catch (err) {
      this.error = "Wystąpił błąd.";
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY H:mm");
    },
    getResult(arr) {
      const result = arr.filter(
        player =>
          player.nickname.toLowerCase() ==
          this.$route.params.nickname.toLowerCase()
      );
      if (result.length > 0 && this.match_details.results.winner == "faction1")
        return "WIN";
      else if (
        result.length > 0 &&
        this.match_details.results.winner == "faction2"
      )
        return "LOSE";
      else if (
        result.length == 0 &&
        this.match_details.results.winner == "faction1"
      )
        return "LOSE";
      else return "WIN";
    },
    getTeamName(faction) {
      if (faction == "faction1") return this.match_details.teams.faction1.name;
      else if (faction == "faction2")
        return this.match_details.teams.faction2.name;
    },
    getFaction() {
      const isInFaction1 = this.match_details.teams.faction1.roster.filter(
        player =>
          player.nickname.toLowerCase() ==
          this.$route.params.nickname.toLowerCase()
      );
      if (isInFaction1.length > 0) return "faction1";
      else return "faction2";
    },
    getTeamIndex(arr) {
      const result = arr.filter(
        player =>
          player.nickname.toLowerCase() ==
          this.$route.params.nickname.toLowerCase()
      );
      if (result.length > 0) return 0;
      else return 1;
    },
    getPlayerStats(team) {
      const playerObj = this.match_stats.rounds[0].teams[team].players.filter(
        player =>
          player.nickname.toLowerCase() ==
          this.$route.params.nickname.toLowerCase()
      );
      return playerObj[0].player_stats;
    }
  },
  computed: {
    KdRatio: function() {
      return parseFloat(
        this.getPlayerStats(
          this.getTeamIndex(this.match_stats.rounds[0].teams[0].players)
        )["K/D Ratio"]
      );
    },
    Deaths: function() {
      return parseFloat(
        this.getPlayerStats(
          this.getTeamIndex(this.match_stats.rounds[0].teams[0].players)
        ).Deaths
      );
    },
    Assists: function() {
      return parseFloat(
        this.getPlayerStats(
          this.getTeamIndex(this.match_stats.rounds[0].teams[0].players)
        ).Assists
      );
    },
    Kills: function() {
      return parseFloat(
        this.getPlayerStats(
          this.getTeamIndex(this.match_stats.rounds[0].teams[0].players)
        ).Kills
      );
    }
  }
};
</script>
